import React from 'react';

export const BoardMapGroupsLayer = ({
  groups = [],
  selectedGroupId = null,
  offsetX = 0,
  offsetY = 0,
  onSelectGroup,
  onEnterGroup,
  onGroupPointerDown,
  selectedGroupLabelRef = null,
  commitSelectedGroupLabel,
}) => {
  return (
    <div className='absolute inset-0' style={{ zIndex: 9, pointerEvents: 'none' }}>
      {groups.map(group => {
        if (!group?.id) {
          return null;
        }
        const x = (Number(group?.x) || 0) + offsetX;
        const y = (Number(group?.y) || 0) + offsetY;
        const w = Math.max(24, Number(group?.w) || 0);
        const h = Math.max(24, Number(group?.h) || 0);
        const isSelected = selectedGroupId === group.id;
        const isEditingLabel = isSelected;

        return (
          <div
            key={group.id}
            data-map-group-root='true'
            className='absolute'
            style={{
              left: x,
              top: y,
              width: w,
              height: h,
              pointerEvents: 'none',
            }}
          >
            <button
              type='button'
              data-map-group-root='true'
              className={`absolute inset-0 rounded border-2 border-dashed ${
                isSelected ? 'border-secondary bg-secondary bg-opacity-10' : 'border-contrast border-opacity-40'
              }`}
              style={{ pointerEvents: 'auto' }}
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onSelectGroup?.(group.id);
              }}
              onPointerDown={event => {
                onGroupPointerDown?.(event, group.id);
              }}
              onDoubleClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onEnterGroup?.(group.id);
              }}
            />
            <span
              data-map-group-label-editor='true'
              ref={isEditingLabel ? selectedGroupLabelRef : null}
              contentEditable={isEditingLabel}
              suppressContentEditableWarning
              className={`absolute left-1 top-1 rounded bg-main bg-opacity-85 px-05 py-px text-xs text-contrast ${
                isEditingLabel
                  ? 'pointer-events-auto outline-none border border-primary border-opacity-40 min-w-10'
                  : 'pointer-events-none'
              }`}
              onPointerDown={event => {
                if (isEditingLabel) {
                  event.stopPropagation();
                }
              }}
              onBlur={event => {
                if (isEditingLabel) {
                  commitSelectedGroupLabel?.(group.id, event.currentTarget.textContent || '');
                }
              }}
              onKeyDown={event => {
                if (!isEditingLabel) {
                  return;
                }
                if (event.key === 'Enter') {
                  event.preventDefault();
                  commitSelectedGroupLabel?.(group.id, event.currentTarget.textContent || '');
                  event.currentTarget.blur();
                }
                if (event.key === 'Escape') {
                  event.preventDefault();
                  event.currentTarget.textContent = group?.label || '';
                  event.currentTarget.blur();
                }
              }}
            >
              {group?.label || 'Groupe'}
            </span>
          </div>
        );
      })}
    </div>
  );
};
